import React, { Component } from 'react';
import { StylesProvider } from "@material-ui/core/styles";

import './SettingsDialog.css'
import '../Dialog.css'

import Dialog           from '@material-ui/core/Dialog';
import DialogTitle      from '@material-ui/core/DialogTitle';
import Select           from '@material-ui/core/Select';
import Button           from '@material-ui/core/Button';
import Divider          from '@material-ui/core/Divider';
import MenuItem         from '@material-ui/core/MenuItem';
import Checkbox         from '@material-ui/core/Checkbox';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

import Plane            from '@material-ui/icons/AirplanemodeActive';
import MapIcon          from '@material-ui/icons/Map';
import LineWeightIcon   from '@material-ui/icons/LineWeight';
import VisibilityIcon   from '@material-ui/icons/Visibility';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import IconButton   from '@material-ui/core/IconButton';

import CloseIcon      from '@material-ui/icons/Close';

export default class SettingsDialog extends Component {
    map = this.props.map
    state = {
        open: false,
        mapOpts: {
            mapTypeId: 'terrain',
            labelType: 'RSA',
            language : 'en', // TODO Not used at the moment
            boxColor : "",
            showAircraft: true,
            showAirports: true,
            showAircraftOnGround: true,
            showClassA: false,
            showClassB: false,
            showClassC: false,
            showClassD: false,
            showDanger: false,
            showRestricted: false,
            showProhibited: false,
        }
    };
    
    componentDidMount() {
        this.getMapOptsFromLocalStorage();
    };
    
    // Local Storage
    getMapOptsFromLocalStorage() {
        // Get settings from localStorage
        let settings = JSON.parse(localStorage.getItem('mapsettings'));
        
        // If mapopts is not null
        if (settings === null)
        return;
        
        // Update settings in state 
        this.setState({ mapOpts: settings });
    }
    
    saveSettingsToLocalStorage() {
        localStorage.setItem('mapsettings', JSON.stringify(this.state.mapOpts));
    }

    // Events
    createAndDispatchEvent() {
        // Create event for sending settings to all components
        let ev = new CustomEvent('newMapOpts', { detail: this.state.mapOpts });
        window.dispatchEvent(ev);
    }
    
    // Handles
    handleClose = (e) => {
        
        // Handle close when save button is pressed
        this.setState({ open: false });
        this.saveSettingsToLocalStorage();
        this.props.onClose();
        this.createAndDispatchEvent();
    };
    
    handleCloseNoSave = (e) => {
        
        this.setState({ open: false }); 
        
        //reset to the previous state from which is still in local storage
        this.getMapOptsFromLocalStorage();
        
        this.props.onClose();
    }
    
    handleChange = (e) => {
        const mapOpts = Object.assign({}, this.state.mapOpts);
        mapOpts[e.target.name] = e.target.value;
        this.setState({ mapOpts });
    }

    handleCheckboxChange = (e) => {
        const mapOpts = Object.assign({}, this.state.mapOpts);
        mapOpts[e.target.name] = e.target.checked;
        this.setState({ mapOpts });
    }

    render() {
        let { open } = this.props;

        return (
            <Dialog onClose={this.handleClose} open={open} id='SettingsDialog'>
            
                <StylesProvider injectFirst>
       
                <div className="settingsTitle">
                    <DialogTitle id="responsive-dialog-title">{"Settings"}</DialogTitle>

                    <div>
                        <IconButton className="closeDialog" onClick={this.handleCloseNoSave}>
                            <CloseIcon edge="end" className="dialogIcon"></CloseIcon>
                        </IconButton>                        
                    </div>
                    
                </div>
                <Divider></Divider>
                <MuiDialogContent className="checkboxes">
                    {/* MAP SETTINGS */}
                    <div>
                        <ul>
                            <li id="fistLine">
                                <MapIcon className="icon"></MapIcon>
                                    <Select
                                        className="dropdown"
                                        onChange={this.handleChange}
                                        value={this.state.mapOpts.mapTypeId}
                                        name='mapTypeId'
                                        id='mapTypeSelect'
                                        >
                                        <MenuItem value="terrain">&nbsp;&nbsp;&nbsp;Terrain</MenuItem>
                                        <MenuItem value="hybrid">&nbsp;&nbsp;&nbsp;Hybrid</MenuItem>
                                        <MenuItem value="satellite">&nbsp;&nbsp;&nbsp;Satellite</MenuItem>
                                    </Select>
                            </li>
                        </ul>
                    </div>
                
                    {/* AIRCRAFT SETTINGS */}
                    <div className="checkboxes" id="showSettings">
                        <ul>
                            <li className="firstLine">
                                <Plane className="icon"></Plane>
                                <Checkbox color="primary" checked={this.state.mapOpts.showAircraft} value={this.state.mapOpts.showAircraft} name='showAircraft' onChange={this.handleCheckboxChange}  />
                                In-Flight
                            </li>
                            <li className="indent">
                                <Checkbox color="primary" checked={this.state.mapOpts.showAircraftOnGround} name='showAircraftOnGround' onChange={this.handleCheckboxChange}/>
                                Not In-Flight
                            </li>
                        </ul>       
                    </div>
        
                    {/* LABEL VISIBILITY */}
                    <div className="checkboxes">
                        <ul>
                            <li className="firstLine">
                                <VisibilityIcon className="icon"></VisibilityIcon>
                                <Select className="dropdown" label="Show Label"onChange={this.handleChange} value={this.state.mapOpts.labelType} name='labelType' id='labelTypeSelect'>
                                    <MenuItem value='N'>&nbsp;&nbsp;&nbsp;None </MenuItem>
                                    <MenuItem value='R'> &nbsp;&nbsp;&nbsp;Registration</MenuItem>
                                    <MenuItem value='RS'>&nbsp;&nbsp;&nbsp;Registration + speed</MenuItem>
                                    <MenuItem value='RSA'>&nbsp;&nbsp;&nbsp;Registration + speed + altitude</MenuItem>
                                </Select>
                            </li>
                        </ul>       
                    </div>

                    
                    {/* AIRPORT SETTINGS */}
                    <div className="checkboxes">
                        <ul>
                            <li className="firstLine"> 
                                <LocationCityIcon className="icon"></LocationCityIcon>
                                <Checkbox color="primary" name='showAirports' value={this.state.mapOpts.showAirports} checked={this.state.mapOpts.showAirports} onChange={this.handleCheckboxChange} />        
                                Airports
                            </li>
                        </ul>       
                    </div>
                    
                    
                    {/* AIRSPACE SETTINGS */}
                        <div className="checkboxes">
                        <ul className="SettingsList">
                            <li className="firstLine"> 
                                <LineWeightIcon className="icon"></LineWeightIcon>
                                <Checkbox color="primary" className="checkbox"  className="checkbox" name='showClassA' value={this.state.mapOpts.showClassA} checked={this.state.mapOpts.showClassA} onChange={this.handleCheckboxChange} />
                                <span for="classA" id="classA" className="flag"></span>
                                &nbsp;Class A
                            </li>
                            <li className="indent"> 
                                <Checkbox color="primary" className="checkbox"  name='showClassB' value={this.state.mapOpts.showClassB} checked={this.state.mapOpts.showClassB} onChange={this.handleCheckboxChange} />                                  
                                <span for="classB" id="classB" className="flag"></span>
                                &nbsp;Class B
                            </li>       
                            <li className="indent"> 
                                <Checkbox color="primary" className="checkbox" name='showClassC' value={this.state.mapOpts.showClassC} checked={this.state.mapOpts.showClassC} onChange={this.handleCheckboxChange} />                                  
                                <span id="classC" className="flag"></span>
                                &nbsp;Class C
                            </li>       
                            <li className="indent"> 
                                <Checkbox color="primary" className="checkbox"  name='showClassD' value={this.state.mapOpts.showClassD} checked={this.state.mapOpts.showClassD} onChange={this.handleCheckboxChange} />                                    
                                <span id="classD" className="flag"></span>
                                &nbsp;Class D
                            </li>       
                            <li className="indent"> 
                                <Checkbox color="primary" className="checkbox"  name='showDanger' value={this.state.mapOpts.showDanger} checked={this.state.mapOpts.showDanger} onChange={this.handleCheckboxChange} />                                    
                                <span id="danger" className="flag"></span>
                                &nbsp;Danger
                            </li>       
                            <li className="indent"> 
                                <Checkbox color="primary" className="checkbox" name='showRestricted' value={this.state.mapOpts.showRestricted} checked={this.state.mapOpts.showRestricted} onChange={this.handleCheckboxChange} />                                     
                                <span id="restricted" className="flag"></span>
                                &nbsp;Restricted
                            </li>
                            <li className="indent"> 
                                <Checkbox color="primary" className="checkbox" name='showProhibited' value={this.state.mapOpts.showProhibited} checked={this.state.mapOpts.showProhibited} onChange={this.handleCheckboxChange} />                                       
                                <span id="prohibited" class="flag"></span>
                                &nbsp;Prohibited
                            </li>

                        </ul>
                    </div>                
                </MuiDialogContent>
                
                <Divider></Divider>
                
                <MuiDialogActions>

                    {/* FORM BUTTONS */}
                    <Button onClick={this.handleCloseNoSave}>CANCEL</Button>
                    <Button className='saveButton'  onClick={this.handleClose}>SAVE</Button>
                </MuiDialogActions>
                </StylesProvider>

            </Dialog>
        )
    };
}
